import { render, staticRenderFns } from "./InvoiceDashboard.vue?vue&type=template&id=1dc82b15"
import script from "./InvoiceDashboard.vue?vue&type=script&lang=js"
export * from "./InvoiceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1dc82b15')) {
      api.createRecord('1dc82b15', component.options)
    } else {
      api.reload('1dc82b15', component.options)
    }
    module.hot.accept("./InvoiceDashboard.vue?vue&type=template&id=1dc82b15", function () {
      api.rerender('1dc82b15', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/dashboard/InvoiceDashboard.vue"
export default component.exports